import { View } from 'backbone.marionette';
import template from './index.jst';
import UserModel from '../../models/User';
import Backbone from 'backbone';

class LoginOldView extends View {
	get template() {
		return template;
	}

	events() {
		return {
			'click @ui.loginBtn': 'login',
			'submit @ui.loginForm': 'login',
			'input @ui.email': 'hideError',
			'input @ui.password': 'hideError'
		};
	}

	ui() {
		return {
			loginBtn: '.js-login',
			loginForm: '.js-login-form',
			email: '.js-email',
			password: '.js-password',
			error: '.js-error-form'
		};
	}

	modelEvents() {
		return {
			'user:logged:in': 'redirectToApp'
		};
	}

	redirectToApp() {
		return Backbone.history.navigate('account', { trigger: true });
	}

	initialize() {
		this.model = UserModel;

		if (!this.model.get('id')) {
			this.model.set({
				id: null
			});
		}
	}

	login(event) {
		event.preventDefault();

		let {
			email: login,
			password,
			error
		} = this.ui;

		login = login.val();
		password = password.val();

		if (login && password) {
			return this.model.login({
				login,
				password
			});
		}

		error.removeClass('hidden');

		return this;
	}

	logout() {
		this.model.logout();
	}

	hideError() {
		let { error } = this.ui;

		if (!error.hasClass('hidden')) {
			error.addClass('hidden');
		}
	}
}

export default LoginOldView;